// components/topology/nodes/HostNode.tsx
import React from 'react';
import { NodeProps, Position } from 'reactflow';
import { HostNodeData } from '../../../interfaces/Rmm';
import BaseAssetNode from './BaseNode';

export function HostNode({ data, selected }: NodeProps<HostNodeData>) {
  const vmCount = data.host.vms?.length ?? 0;

  return (
    <BaseAssetNode
      width={330}
      selected={selected}
      rmm={data.rmm}
      title={<>🖥 {data.host.name}</>}
      subtitle={data.host.fqdn || data.host.os}
      badges={
        <>
          <span className="text-[11px] px-2 py-1 rounded-full bg-slate-100">
            {vmCount} VM{vmCount === 1 ? '' : 's'}
          </span>

          {typeof data.host.memoryGB === 'number' && (
            <span className="text-[11px] px-2 py-1 rounded-full bg-emerald-50 text-emerald-800">
              {data.host.memoryGB} GB
            </span>
          )}

          {data.host.cpu?.cores && (
            <span className="text-[11px] px-2 py-1 rounded-full bg-indigo-50 text-indigo-800">
              {data.host.cpu.cores} cores
            </span>
          )}
        </>
      }
      handle={{ type: 'source', position: Position.Bottom }}
    />
  );
}

export default HostNode;
